import { apiClient } from 'client/core/network/apiClient';
import { IUser } from 'common/schema/User';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import {
  IUsersQueryDto,
  IUserCreateDto,
  IUserEditDto,
  IUserTesterEditDto,
  IUserSetPasswordDto
} from 'common/dto/UserDto';

export interface CreateServiceTokenResult {
  serviceToken: string;
  serviceTokenJwt: string;
}

export const UserApi = {
  findCurrentUser: (opts: {}) => apiClient.get<IUser>(`/users/current`),
  find: (opts: { id: number }) => apiClient.get<IUser>(`/users/${opts.id}`),
  create: (opts: { input: IUserCreateDto }) =>
    apiClient.post<IUser>(`/users`, opts.input),
  update: (opts: { id: number; input: IUserEditDto }) =>
    apiClient.put<IUser>(`/users/${opts.id}`, opts.input),
  updateTester: (opts: { id: number; input: IUserTesterEditDto }) =>
    apiClient.put<IUser>(`/users/${opts.id}/actions/tester`, opts.input),
  list: (opts: { query: IUsersQueryDto }) =>
    apiClient.get<PaginatedResult<IUser>>(`/users`, { params: opts.query }),
  listTester: (opts: { query: IUsersQueryDto }) =>
    apiClient.get<PaginatedResult<IUser>>(`/users/projections/tester`, {
      params: opts.query
    }),
  listUserCitizens: (opts: { query: IUsersQueryDto }) =>
    apiClient.get<PaginatedResult<IUser>>(`/users/projections/user-citizen`, {
      params: opts.query
    }),
  /** Elenco di utenti per le select */
  // listSelectable: (opts: { query: IUsersQueryDto }) =>
  //   apiClient.get<PaginatedResult<IUser>>(`/users/projections/selectable`, {
  //     params: opts.query
  //   }),
  delete: (opts: { id: number }) => apiClient.delete(`/users/${opts.id}`),
  /** Crea un service token */
  createServiceToken: (opts: { id: number }) =>
    apiClient.post<CreateServiceTokenResult>(
      `/users/${opts.id}/actions/create-service-token`
    ),

  /** Invia la mail per la creazione di una password */
  sendAcceptanceNotification: (opts: { id: number }) =>
    apiClient.post(`/users/${opts.id}/actions/send-acceptance`),

  /** Imposta una nuova password dopo la ricezione della email, utilizzato per i commissari */
  setPassword: (opts: { input: IUserSetPasswordDto }) =>
    apiClient.post(`/users/actions/set-password`, opts.input)
};
